import React from 'react';
import PropTypes from 'prop-types';
import FormControl from './FormControl';
import Radio from 'react-bootstrap/lib/Radio';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Icon from '../../Icon';
import i18n from '../../../../src/i18n/translate';
import { kebabCase } from 'lodash';

export default class RadioGroupControl extends FormControl {
  static propTypes = {
    name: PropTypes.string.isRequired,
    valueList: PropTypes.array.isRequired,
    valueKey: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    dataValue: PropTypes.string,
    onChange: PropTypes.func,
    onValueChange: PropTypes.func,
    truncateSize: PropTypes.number,
    controlLabelText: PropTypes.string,
    tooltip: PropTypes.string,
    inline: PropTypes.bool
  }

  static defaultProps = {
    dataValue: '',
    inline: false
  };

  constructor(props) {
    super(props);
    this.state = {
      showMoreValues: props.truncateSize ? false : true,
      value: props.dataValue
    };
  }

  onClick = (e) => {
    const value = e.target.value;
    this.setState({ value });
    if(this.props.onChange){
      this.props.onChange(value);
    }
  }

  toggleShowMore = () => {
    this.setState({
      showMoreValues: !this.state.showMoreValues
    })
  }

  render(){
    const { valueList, truncateSize, valueKey, labelKey, inline } = this.props;
    if (!valueList) {
      return;
    }
    const { showMoreValues } = this.state;
    const truncatedValueList = showMoreValues || !truncateSize ? valueList :  valueList.slice(0, truncateSize);
    const className = inline ? 'di-block m-l-10' : null;

    return (
      <div>
        { this.props.controlLabelText &&<ControlLabel>{this.props.controlLabelText}</ControlLabel>}
        { this.props.tooltip && <OverlayTrigger placement="top" overlay={(<Tooltip>{this.props.tooltip}</Tooltip>)}>
          <span><Icon iconType="help-outline" additionalClasses="p-l-5" /></span>
        </OverlayTrigger> }
        <FormGroup>
          {
            truncatedValueList.map(item => (
              <Radio key={item[valueKey]} value={item[valueKey]} className={className} name={this.props.name} checked={String(item[valueKey]) === String(this.state.value)} onClick={this.onClick} disabled={this.props.disabled} data-object-action={`select-${kebabCase(item[labelKey])}`}>
                <i className="input-helper"/>{item[labelKey]}
              </Radio>
            ))
          }
          { truncateSize < valueList.length ?
            <div className="show-more-link">
              <a onClick={this.toggleShowMore} >{this.state.showMoreValues ? i18n.t("Show Less") : i18n.t("Show More")}</a>
            </div> : null
          }
        </FormGroup>
      </div>
    )
  }
}
